<template>
  <div class="model-title-bar pb-3">
    <div class="d-flex">
      <h2 class="fw-bold text-uppercase p-1 flex-grow-1">
        {{ title ?? trans(`models.${resourceType}.content.${action}.action`) }}
      </h2>
      <slot />
      <resource-action-buttons
        :button-class="'btn btn-primary text-secondary'"
        :model="model"
        :resource-type="resourceType"
        :source-action="action"
      ></resource-action-buttons>
    </div>
    <div v-if="hasDescription(trans)" class="card rounded-corner">
      <div class="card-body">
        <p class="card-text">
          {{ description ?? trans(`models.${resourceType}.content.${action}.description`) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceActionButtons from '@kanrisha/components/Links/ResourceActionButtons';
import useResource from '@kanrisha/composables/useResource';

export default {
  components: {
    ResourceActionButtons,
  },
  props: {
    model: { type: Object, default: null },
    action: { type: String, default: 'index' },
    title: { type: String, default: null },
    description: { type: String, default: null },
  },
  emits: [],
  setup(props) {
    const { meta, resourceType } = useResource(props, props.model);

    const hasDescription = (trans) => {
      if (props.description) {
        return true;
      }

      let transString = `models.${resourceType.value}.content.${props.action}.description`;
      let translation = trans(transString);

      return translation && translation !== transString;
    };

    return {
      hasDescription,
      meta,
      resourceType,
    };
  },
};
</script>
